import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TablerIconsModule } from 'angular-tabler-icons';
import { UserAuthService } from 'src/app/auth/userAuth.service';
import { CoutryStateCityService } from 'src/app/common/country-state-city.service';
import { LoginService } from 'src/app/login.service';
import { MaterialModule } from 'src/app/material.module';
import { HospitalService } from '../../hospital/hospital.service';
import { ToastrService } from 'ngx-toastr';
import { RouterModule } from '@angular/router';
import { AppBreadcrumbComponent } from "../../../layouts/full/shared/breadcrumb/breadcrumb.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BillChargeComponent } from "./bill-charge/bill-charge.component";
import { Subject } from 'rxjs';
import { LoaderComponent } from "src/app/shared/loader/loader.component";
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { DoctorSpecialityComponent } from './doctor-speciality/doctor-speciality.component';
import { ValidationService } from 'src/app/common/validation/validation.service';
import { AllowOnlyDigitsDirective } from 'src/app/common/directive/allow-only-digits.directive';
import { PrintSettingComponent } from './print-setting/print-setting.component';
import { IHospitalInfo } from '../../hospital/ihospital-info';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { environment } from 'src/environments/environment';
import { HospitalStateService } from 'src/app/services/hospitalstate.service';
@Component({
  selector: 'app-hospital-setting',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TablerIconsModule,
    MaterialModule,
    RouterModule,
    AppBreadcrumbComponent,
    BillChargeComponent,
    TranslateModule,
    LoaderComponent,
    DoctorSpecialityComponent,
    AllowOnlyDigitsDirective,
    PrintSettingComponent
  ],
  templateUrl: './hospital-setting.component.html',
  styleUrl: './hospital-setting.component.scss'
})
export class HospitalSettingComponent implements OnInit, OnDestroy {
  hospitalDetailsForm: FormGroup;
  Countries: any[] = [];
  states: any = [];
  cities: any = [];
  hospitalID: any;
  hospitaldetailsfill: IHospitalInfo;
  isLoading: boolean = false;
  isAdmin: boolean;
  private destroy$ = new Subject<void>();
  showAddPhotoOverlay = false;
  defaultAvatarPath = 'assets/images/profile/user-1.jpg';
  selectedImage: File | null = null;
  imageUrl: string | ArrayBuffer | null = null;
  base64Image: string | null = null;
  staticimagepath = environment.imagePath;
  hidePan = true;

  constructor(
    private _coutrystatecityService: CoutryStateCityService,
    private _formBuilder: FormBuilder,
    private _userHospitalService: UserAuthService,
    private _loginService: LoginService,
    private _hospitalService: HospitalService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private translationUtils: TranslationUtils,
    private cdr: ChangeDetectorRef,
    private _hospitalStateService: HospitalStateService
  ) {
    this.Countries = this._coutrystatecityService.getCountries();
    this.hospitalID = this._loginService.getHospitalFromToken();
    const userId = this._loginService.getUserId();
    if (userId) {
      this._userHospitalService.get(userId).subscribe((data) => {
        const roles = data.result?.roleName ? data.result?.roleName.split(',').map((r: string) => r.trim()) : [];
        this.isAdmin = roles.includes("Admin") || roles.includes("Doctor");
      });
    }
  }

  ngOnInit(): void {
    this.loaderService.show();
    this.hospitalDetailsForm = this._formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      panNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), ValidationService.panNumberValidator]],
      registrationNumber: ['', [Validators.required, Validators.maxLength(20), ValidationService.alphaNumericValidator]],
      phone: ['', [Validators.pattern(/^[6-9]\d{9}$/), Validators.required, Validators.minLength(10), Validators.maxLength(10), ValidationService.phoneNumberValidator]],
      mobile: ['', [Validators.required, ValidationService.phoneNumberValidator, Validators.minLength(10), Validators.maxLength(10)]],
      country: [''],
      state: [''],
      city: [''],
      postalCode: ['', [ValidationService.numericValidator, Validators.minLength(6), Validators.maxLength(6)]],
      address: ['', Validators.required],
      isIPD: [],
    });

    this.hospitalDetailsForm.get('country')?.valueChanges.subscribe((selectedCountry) => {
      this.onCountryChange(selectedCountry);
    });

    this.hospitalDetailsForm.get('state')?.valueChanges.subscribe((selectedState) => {
      this.onStateChange(selectedState);
    });

    this._userHospitalService.getHospital(this.hospitalID).subscribe((data) => {
      this.hospitaldetailsfill = data.result;

      this.hospitalDetailsForm.patchValue({
        name: this.hospitaldetailsfill.name,
        panNumber: this.hospitaldetailsfill.panNumber,
        registrationNumber: this.hospitaldetailsfill.registrationNumber,
        phone: this.hospitaldetailsfill.phone,
        mobile: this.hospitaldetailsfill.mobile,
        country: this.hospitaldetailsfill.country,
        state: this.hospitaldetailsfill.state,
        city: this.hospitaldetailsfill.city,
        postalCode: this.hospitaldetailsfill.postalCode,
        address: this.hospitaldetailsfill.address,
        isIPD: this.hospitaldetailsfill.isIPD,
      });
      setTimeout(() => {
        this.loaderService.hide();
      }, 500)
    })
  }

  get logoUrl(): any {
    if (this.imageUrl) {
      return this.imageUrl;
    }
    return this.hospitaldetailsfill?.logo ? this.staticimagepath + this.hospitaldetailsfill.logo : this.defaultAvatarPath;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCountryChange(country: string) {
    const selectedCountry = this.Countries.find(a => a.name === country);
    const countryIsoCode = selectedCountry ? selectedCountry.isoCode : '';
    this.states = this._coutrystatecityService.getStatesByCountry(countryIsoCode);
    this.hospitalDetailsForm.get('state')?.setValue('');
    this.cities = [];
  }

  onStateChange(state: string) {
    const selectedState = this.states.find((s: { name: string; }) => s.name === state);
    const stateIsoCode = selectedState ? selectedState.isoCode : '';
    const selectedCountry = this.Countries.find(country => country.name === this.hospitalDetailsForm.get('country')?.value);
    const countryIsoCode = selectedCountry ? selectedCountry.isoCode : '';
    this.cities = this._coutrystatecityService.getCitiesByState(countryIsoCode, stateIsoCode);
    this.hospitalDetailsForm.get('city')?.setValue('');
  }

  onUpdateHospital() {
    if (this.hospitalDetailsForm.invalid) {
      this.hospitalDetailsForm.markAllAsTouched();
      return;
    }
    const formData = new FormData();
    Object.entries(this.hospitalDetailsForm.getRawValue()).forEach(([key, value]) => {
      formData.append(key, value as string);
    });
    formData.append("id", this.hospitaldetailsfill.id.toString());

    if (this.selectedImage) {
      formData.append("logo", this.selectedImage);       // <-- FILE
    }
    this._hospitalService.updateHospital(formData).subscribe((res) => {
      if (res.isSuccess) {
        this._hospitalStateService.setHospital(res.result);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('HOSPITALDETAILS')));
      } else {
        const allErrors = Object.values(res.errors).flat();
        this.toastr.error(allErrors.join("\n"));
      }
    })

  }

  onFileChanged(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length > 0) {
      const file = target.files[0];
      const reader = new FileReader();
      this.selectedImage = file;
      reader.onload = () => {
        this.imageUrl = reader.result;
        this.base64Image = reader.result as string;
        this.cdr.detectChanges();
      };
      reader.readAsDataURL(file);
    }
    this.showAddPhotoOverlay = false;
  }

  removePhoto() {
    this.imageUrl = '';
  }

}